import React from "react";
import {
  HomeContainer,
  HomeTitle,
  HomeParagraph,
  HomeButtons,
  MainHome,
} from "../../library/home";
import { Button, Image } from "../../library/components";
import HomeImage from "../../assets/home.svg";
import * as Scroll from "react-scroll";

const Home = () => {
  let Link = Scroll.Link;

  return (
    <div style={{ backgroundColor: "#C8F8FF" }}>
      <MainHome>
        <HomeContainer>
          <HomeTitle>Estamos comprometidos con vos y el ambiente!</HomeTitle>
          <HomeParagraph>
            Somos una compañía joven que cuenta con profesionales <br />
            de vasta experiencia en la industria del oil&gas
          </HomeParagraph>
          <HomeButtons>
            <Button primary width="100%">
              <Link
                activeClass="active"
                to="contact"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                Contactános
              </Link>
            </Button>
          </HomeButtons>
        </HomeContainer>
        <Image className="m-none" width="48%" src={HomeImage} />
      </MainHome>
    </div>
  );
};

export default Home;
